export const destinyValues = [
  {
    'key': 'NL',
    'value': 'NL',
    'text': 'NORMAL',
  },
  {
    'key': 'FL',
    'value': 'FL',
    'text': 'FLOTANTE',
  },
  {
    'key': 'DP',
    'value': 'DP',
    'text': 'DEPÓSITO',
  },
  {
    'key': 'DN',
    'value': 'DN',
    'text': 'DIPLOMÁTICO NACIONAL',
  },
  {
    'key': 'DE',
    'value': 'DE',
    'text': 'DIPLOMÁTICO EXTRANJERO',
  },
];
